/*
 * @Author: Code-HHX
 * @Date: 2022-03-24 11:49:13
 * @LastEditors: Code-HHX
 * @LastEditTime: 2022-04-20 11:48:30
 * @Description:
 */
import Vue from "vue";
import VueRouter from "vue-router";
import { TOKEN } from "@/config/http-json";
import store from "./store";
import { getQueryVariable } from "@/util/utils";

Vue.use(VueRouter);

export const routes = [
  {
    //登录页
    path: "/Login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
    meta: {
      title: "Login",
      auth: false //是否登录鉴权
    }
  },
  // {
  //   //功能页
  //   path: "/Function",
  //   name: "Function",
  //   component: () => import("@/views/Function.vue"),
  //   meta: {
  //     auth: true //是否登录鉴权
  //   }
  // },
  {
    //NFC页
    path: "/Connect",
    name: "Connect",
    component: () => import("@/views/Connect.vue"),
    meta: {
      title: "Connect",
      auth: true, //是否登录鉴权
      keepAlive: true
    }
  },

  {
    //应用首页
    path: "/Home",
    name: "Home",
    component: () => import("@/views/Home.vue"),
    meta: {
      title: "Home",
      auth: true //是否登录鉴权
    }
  },
  {
    //应用首页
    path: "/Enterprise",
    name: "Enterprise",
    component: () => import("@/views/EnterpriseHome.vue"),
    meta: {
      title: "Home-NFC",
      auth: true, //是否登录鉴权
      keepAlive: true
    }
  },
  {
    //应用首页
    path: "/nico",
    name: "NicoHome",
    component: () => import("@/views/NicoHome.vue"),
    meta: {
      title: "NicotineHome",
      auth: true, //是否登录鉴权
      keepAlive: true
    }
  },
  {
    //应用首页
    path: "/bt-home",
    name: "BtHome",
    component: () => import("@/views/BtHome.vue"),
    meta: {
      title: "Home-BT",
      auth: true, //是否登录鉴权
      keepAlive: true
    }
  },
  {
    //应用首页（新版）
    path: "/NewHome",
    name: "NewHome",
    component: () => import("@/views/NewHome.vue"),
    meta: {
      auth: true, //是否登录鉴权
      keepAlive: true
    }
  },
  {
    //找回密码
    path: "/Retrieve",
    name: "Retrieve",
    component: () => import("@/views/Retrieve.vue"),
    meta: {
      auth: false //是否登录鉴权
    }
  },
  {
    //注册页面
    path: "/Register",
    name: "Register",
    component: () => import("@/views/Register.vue"),
    meta: {
      auth: false //是否登录鉴权
    }
  },
  {
    //历史记录
    path: "/History",
    name: "History",
    component: () => import("@/views/History.vue"),
    meta: {
      title: "All History",
      auth: true //是否登录鉴权
    }
  },
  {
    //历史记录
    path: "/Favorite",
    name: "Favorite",
    component: () => import("@/views/Favorite.vue"),
    meta: {
      title: "Favorite",
      auth: true //是否登录鉴权
    }
  },
  {
    //历史记录
    path: "/MyBrand",
    name: "MyBrand",
    component: () => import("@/views/MyBrand.vue"),
    meta: {
      title: "My Brand",
      auth: true,//是否登录鉴权
      keepAlive: true
    }
  },
  {
    //历史记录
    path: "/PrivacyPolicy",
    name: "PrivacyPolicy",
    component: () => import("@/views/PrivacyPolicy.vue"),
    meta: {
      title: "Privacy Policy",
      auth: true,//是否登录鉴权
      keepAlive: false
    }
  },
  {
    //历史记录
    path: "/BrandRecord",
    name: "BrandRecord",
    component: () => import("@/views/BrandRecord.vue"),
    meta: {
      title: "Brand Record",
      auth: true //是否登录鉴权
    }
  },
  {
    //历史记录
    path: "/AppSettings",
    name: "AppSettings",
    component: () => import("@/views/AppSettings.vue"),
    meta: {
      title: "Mine",
      auth: true //是否登录鉴权
    }
  },
  {
    //历史记录
    path: "/customization",
    name: "Customization",
    redirect: "/customization/brand",
    component: () => import("@/views/customization/Customization.vue"),
    children: [
      {
        path: "brand",
        component: () => import("@/views/customization/Brand.vue"),
        meta: {
          title: "CustomizationBrand",
          auth: true //是否登录鉴权
        }
      },
      {
        path: "product",
        component: () => import("@/views/customization/Product"),
        meta: {
          title: "CustomizationProduct",
          auth: true //是否登录鉴权
        }
      },
      {
        path: "flavor",
        component: () => import("@/views/customization/Flavor"),
        meta: {
          title: "CustomizationFlavor",
          auth: true //是否登录鉴权
        }
      },
      {
        path: "history",
        component: () => import("@/views/customization/History"),
        meta: {
          title: "CustomizationHistory",
          auth: true //是否登录鉴权
        }
      }
    ],
    meta: {
      keepAlive: true,
      auth: true //是否登录鉴权
    }
  },

  { //设置口味
    path: "/set-flavor",
    name: "SetFlavor",
    component: () => import("@/views/customization/SetFlavor.vue"),
    meta: {
      title: "Set Flavor",
      auth: true //是否登录鉴权
    }
  },

  { //omni助手
    path: "/omni-assistant",
    name: "Assistant",
    component: () => import("@/views/assistant/Index.vue"),
    meta: {
      title: "Assistant",
      auth: true //是否登录鉴权
    }
  },

  {
    //历史记录
    path: "/ThemeTemplate",
    name: "ThemeTemplate",
    component: () => import("@/views/ThemeTemplate.vue"),
    meta: {
      auth: false //是否登录鉴权
    }
  },
  {
    //历史记录
    path: "/LoginOptions",
    name: "LoginOptions",
    component: () => import("@/views/LoginOptions.vue"),
    meta: {
      title: "LoginOptions",
      auth: true //是否登录鉴权
    }
  },
  {
    //历史记录
    path: "/favorite-device",
    name: "MyFavoriteDevice",
    component: () => import("@/views/MyFavoriteDevice.vue"),
    meta: {
      title: "Favorite Devices",
      auth: true //是否登录鉴权
    }
  },
  {
    //历史记录
    path: "/notifications",
    name: "Notifications",
    component: () => import("@/views/Notification.vue"),
    meta: {
      title: "Notification List",
      auth: false //是否登录鉴权
    }
  },
  {
    //历史记录
    path: "/notification-detail",
    name: "NotificationsDetail",
    component: () => import("@/views/NotificationDetail.vue"),
    meta: {
      title: "Notification Detail",
      auth: false //是否登录鉴权
    }
  },
  {
    //历史记录
    path: "/mydevices",
    name: "MyDevices",
    component: () => import("@/views/MyDevices.vue"),
    meta: {
      title: "My Brand's Device",
      auth: false //是否登录鉴权
    }
  },
  {
    //历史记录
    path: "/hub-devices",
    name: "HubDevices",
    component: () => import("@/views/HubDevices.vue"),
    meta: {
      title: "Search Bluetooth Devices",
      auth: true //是否登录鉴权
    }
  },
  {
    //历史记录
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("@/views/ResetPassword.vue"),
    meta: {
      title: "Reset Password",
      auth: true //是否登录鉴权
    }
  },
  {
    //历史记录
    path: "/profile",
    name: "Profile",
    component: () => import("@/views/EditPersonalInfo.vue"),
    meta: {
      title: "User Profile",
      auth: true //是否登录鉴权
    }
  },
  {
    path: "*",
    redirect: {
      name: "Login"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

let isFirstLoad = true;
router.beforeEach((to, from, next) => {
  //to要跳转到的路径
  //from从哪个路径来
  //next往下执行的回调
  //在localStorage中获取token

  let token = window.localStorage.getItem(TOKEN);

  //判断该页面是否需要登录
  //如果token存在直接跳转
  if (token) {
    const userInfo = store.state.user.userInfo;
    const nfcInfo = store.state.nfc;
    const isBrandUser = userInfo.supplierId === 0;
    // Store.commit("setLoginInfo", userInfo);
    if (to.fullPath.toLowerCase() === "/login" || to.fullPath === "/register" || to.fullPath === "/retrieve") {
      //看看上次访问的是Connect 还是蓝牙

      if (userInfo.supplierId !== 0 && userInfo.identityConfirmStatus !== 1) {
        next({
          path: "/LoginOptions"
        });
        return;
      }
      if (!userInfo.agreementReadStatus) {
        next({
          path: "/PrivacyPolicy"
        });
        return;
      }

      const lastPath = localStorage.getItem("last_path") || "Enterprise";
      // debugger;
      if (to.path === "bt-home" || to.path === "Enterprise" || to.path === "nico") {
        return;
      }
      next({
        path: lastPath
      });
      return;
      // const hash = window.location.hash.replace("#/", "") || getQueryVariable("hash");
      // store.commit("setHash", hash);
      //
      // if (isFirstLoad) {
      //   isFirstLoad = false;
      //   const lastVisitPath = localStorage.getItem("last_visit_path");
      //   if (lastVisitPath) {
      //     next({ name: lastVisitPath, query: to.query });
      //     // next();
      //   } else {
      //     next('Enterprise');
      //   }
      //   return;
      // }
    }

    if (to.fullPath.toLowerCase() === "/loginoptions") {
      if (userInfo.supplierId === 0) {
        if (userInfo.agreementReadStatus === 1) {
          next("/Enterprise");
        } else {
          next("/PrivacyPolicy");
        }
      }
      if (userInfo.identityConfirmStatus === 1 && userInfo.agreementReadStatus !== 1) {
        next("/PrivacyPolicy");
        return;
      }
      if (userInfo.agreementReadStatus === 1 && userInfo.identityConfirmStatus === 1) {
        const defaultHomeData = isBrandUser ? nfcInfo.defaultBHomeData : nfcInfo.defaultCHomeData;
        console.log(defaultHomeData);
        if (!!defaultHomeData) {
          if (defaultHomeData.oilType === 1) {
            next("/nico");
            return;
          }
        }
        next("/Enterprise");
        return;
      }
    }

    if (to.fullPath.toLowerCase() === "/privacypolicy") {
      if (userInfo.supplierId !== 0 && userInfo.identityConfirmStatus === 0) {
        next("/LoginOptions");
        return;
      }
      if (userInfo.agreementReadStatus === 1 && userInfo.identityConfirmStatus !== 1) {
        next("/LoginOptions");
        return;
      }
      if (userInfo.agreementReadStatus === 1 && userInfo.identityConfirmStatus === 1) {
        const defaultHomeData = isBrandUser ? nfcInfo.defaultBHomeData : nfcInfo.defaultCHomeData;
        console.log(defaultHomeData);
        if (!!defaultHomeData) {
          if (defaultHomeData.oilType === 1) {
            next("/nico");
            return;
          }
        }
        next("/Enterprise");
        return;
      }
    }

    if (from.fullPath === "/" && (to.fullPath === "/Enterprise")) {
      const lastPath = localStorage.getItem("last_path");
      // console.log(`last path = ${lastPath}`)
      if (lastPath !== "/Enterprise") {
        next(lastPath);
        return;
      }
    }

    gtag("path", to.fullPath);
    next();
  } else {
    if (to.meta.auth) {
      next({
        path: "/",
        //跳转时传递参数到登录页面，以便登录后可以跳转到对应页面
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      //如果不需要登录鉴权，则直接跳转到对应页面
      gtag("path", to.fullPath);
      next();
    }
  }
  // if (to.meta.title) {
  //   document.title = to.meta.title
  // }
  if (to.meta.title) {
    gtag("event", "page_view", {
      "page_title": to.meta.title,
      "page_path": window.location.pathname
    });
  }

});

export default router;
